import { STATUS } from "constants/fetchStatus"
import { store } from "index"

export const parseActiveExchangesFromKeys = () => {
    const keys = store.getState().keys.data
    return keys.filter(exchange => (exchange.isActive !== false && exchange.status === STATUS.OK)).map(key => key.exchange)
}